// הפעולות שמתחת לתור האחרון (15 "להמשך"): קומפוננטה אחת שהיא ה-<nav aria-label="להמשך"> היחיד,
// מחזיקה את תנאי ההצגה (done, לא חי, שדה ריק, canContinue, outbox ריק) ומרנדרת כל פריט דרך אותו Chip.
// הצעות המודל בלבד (skills-18-deprecate: "שמור ככישור" הוסר). לחיצה שולחת את ה-prompt כהודעת המשתמש (אותו מסלול כמו הקלדה);
// <button> אמיתיים — Tab + Enter/Space. במובייל טור ברוחב מלא; בדסקטופ שורה עם גלישה. התוכן מהמודל — מוצג כטקסט בלבד.
import type { TurnView } from '../../lib/conversationModel.ts';
import { T } from '../../lib/strings.ts';

type Item = { key: string; testId: string; labelHe: string; prompt: string };

const CHIP_CLASS =
  'inline-flex min-h-11 w-full cursor-pointer items-center justify-start rounded-sm border border-primary/30 bg-primary-soft px-4 py-2 text-start text-sm font-medium text-primary transition-colors hover:border-primary/60 hover:bg-primary/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-action disabled:cursor-default disabled:opacity-60 md:w-auto';

function Chip({ item, onPick, disabled }: { item: Item; onPick: (prompt: string) => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onPick(item.prompt)}
      title={item.prompt !== item.labelHe ? item.prompt : undefined}
      data-testid={item.testId}
      className={CHIP_CLASS}
    >
      <span aria-hidden="true" className="me-2 text-primary/70">
        ←
      </span>
      <span className="whitespace-normal break-words">{item.labelHe}</span>
    </button>
  );
}

export function TurnActions({
  turn,
  live,
  textEmpty,
  canContinue,
  outboxEmpty,
  disabled,
  onPick,
}: {
  turn: TurnView | undefined;
  live: boolean;
  textEmpty: boolean;
  canContinue: boolean;
  outboxEmpty: boolean;
  disabled?: boolean;
  onPick: (prompt: string) => void;
}) {
  if (!turn || turn.status !== 'done' || live || !textEmpty || !canContinue || !outboxEmpty) return null;
  const items: Item[] = [
    ...(turn.suggestions ?? []).map((s, i) => ({ key: `s${i}`, testId: 'next-step', labelHe: s.labelHe, prompt: s.prompt })),
  ];
  if (!items.length) return null;
  return (
    <nav aria-label={T.ai.nextSteps} className="flex flex-col gap-2 md:flex-row md:flex-wrap" data-testid="next-steps">
      <span className="sr-only">{T.ai.nextStepsHint}</span>
      {items.map((it) => (
        <Chip key={it.key} item={it} onPick={onPick} disabled={disabled} />
      ))}
    </nav>
  );
}
